import { createFileRoute } from '@tanstack/react-router'

import { ProjectsPage } from '@/pages/projects/Projects.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/',
)({
  component: ProjectsPage,
})
